(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom_subscriptions_block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscribe-custom-widget')) {
  class SubscribeCustomWidget extends HTMLElement {
      constructor() {
          super();

          this.closestSelector = '.product-info'
          const productId = this.dataset.productid;
          this.uniqid = this.dataset.uniqid || null
          this.subscribeOnetimeInput = this.querySelector(`#subscribe-custom-onetime-${productId}-${this.uniqid ? this.uniqid : ''}`)
          this.subscribeOptionsInput = this.querySelector(`#subscribe-custom-options-${productId}-${this.uniqid ? this.uniqid : ''}`)
          this.jsSubscribeOptions = this.querySelector('.js-subscribe-options')
          this.jsDiscountLabel = this.querySelector('.js-discount-label')
          this.selectDropDown = this.querySelector('.js-subscribe-options-selected')

          this.variantId = ''

          // this.variantSwatchInputs = document.querySelectorAll('variant-selects .select__select')
        
      }

      connectedCallback() {
          
        this.getProductObject()


      
      }

      async getProductObject(){
    
          try{
            const runFetchProduct = await fetch(this.dataset.url)
            const data = await runFetchProduct.json()
          
            if(data.selling_plan_groups.length){

              //run render html plans list
              this.renderSellingPlanGroups(data)

              //run code  
              this.subscribeOnetime()

              
              this.variantProductChange(data);

                this.style.display = 'block'

            }else{
                this.style.display = 'none'
            }
          }catch(error){
            return false
          }
        
      }



    renderSellingPlanGroups(productObject){
  
      const data = productObject

    //    console.log(data)

      this.jsSubscribeOptions.innerHTML = `
        ${data.selling_plan_groups.map((item, index) => item.selling_plans.map(plan => `
            <input type="radio" 
            class="js-custom-plan-input" name="plan" 
            id="plan-${plan.id}-${this.uniqid ? this.uniqid : ''}" 
            ${index === 0 ? 'checked' : ''}
            value="${plan.id}"
            data-discount="${plan.price_adjustments[0]?.value}"
            >
            <label for="plan-${plan.id}-${this.uniqid ? this.uniqid : ''}" class="custom-plan-label">${plan.name}</label>
          `).join('')
        ).join('')
        }
      `

      if(this.closest(this.closestSelector).querySelectorAll('form input[name="selling_plan"]').length === 0){
        
      }
      const createElementSelingPlan = document.createElement('input')
              createElementSelingPlan.name = 'selling_plan'
              createElementSelingPlan.type = 'hidden'
        this.closest(this.closestSelector).querySelector('.product-form form[action="/cart/add"]').prepend(createElementSelingPlan)
      this.querySelectorAll('.js-custom-plan-input').forEach(input => {
        input.addEventListener('change', (e) => {
          e.preventDefault()
          //  console.log(productObject)
          //  console.log(this.variantId)
          this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = e.currentTarget.value
          if(this.selectDropDown){
                this.selectDropDown.textContent = e.currentTarget.nextElementSibling.textContent
                this.jsDiscountLabel.innerHTML = e.currentTarget.dataset.discount ? 'Save ' + e.currentTarget.dataset.discount + '%' : ''

                this.subscribePriceChange(data, e.currentTarget.value)
            }
        })
      })


      this.jsDiscountLabel.innerHTML = `Save ${data.selling_plan_groups[0].selling_plans[0]?.price_adjustments[0]?.value}%` || ''


        

    } 



    subscribePriceChange(productObject, currentPlanId){

      const data = productObject

      const getCurrentVariant = data.variants.find(id => id.id == this.variantId)
      const getCurrentSubscribePrice = getCurrentVariant.selling_plan_allocations.find(id => id.selling_plan_id == currentPlanId )      
      this.querySelector('.js-subscription-purchase-price').innerHTML = '$'+getCurrentSubscribePrice.price / 100

    }
 


    subscribeOnetime(){

        this.subscribeOnetimeInput.addEventListener('change', (e) => {
          if(e.currentTarget.checked){
              this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = '';
              if(this.selectDropDown){
                this.selectDropDown.classList.remove('active')
              }
          }
        })
        this.subscribeOptionsInput.addEventListener('change', (e) => {
       
          if(e.currentTarget.checked){
            this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = this.querySelector('.js-custom-plan-input:checked').value
            if( this.selectDropDown){
                 this.selectDropDown.textContent = this.querySelector('.js-custom-plan-input:checked + label').textContent
            }
          }
           
        })
        if(this.subscribeOptionsInput.checked){
          this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = this.querySelector('.js-custom-plan-input:checked').value
         
        }

         if(this.selectDropDown){
             this.selectDropDown.textContent = this.querySelector('.js-custom-plan-input:checked + label').textContent
          }

        this.selectDropDownToggle()
        
    }

    selectDropDownToggle(){
        if (this.selectDropDown){
             this.selectDropDown.addEventListener('click', (e) => {
                if(!e.currentTarget.classList.contains('active')){
                    e.currentTarget.classList.add('active')
                }else{
                    e.currentTarget.classList.remove('active')
                }
             })

             this.querySelectorAll('.js-custom-plan-input').forEach(item => {
              item.addEventListener('change', (e) => {
                this.selectDropDown.classList.remove('active')
              })
             })
        }
    }

    variantProductChange(data) {
        const container = this.closest(this.closestSelector).querySelector('.product__info-container'); 
    
    // console.log(container)

        if (!container) return;

        const changePrice = () => {
          setTimeout(() => {

              const getJsonScriptArrayIds = this.closest(this.closestSelector).querySelector('script[data-selected-variant]'); 
         
              const getScriptJsonParse = JSON.parse(getJsonScriptArrayIds.innerHTML)
            
          
            const locationVarinaId = getScriptJsonParse.id || null

            this.variantId = locationVarinaId
             
            const catchVariant = (currentVariant) => {
              const getCurrentPrice = (currentVariant.price / 100);
              const getSellingCurrentPrice = (currentVariant.selling_plan_allocations[0].price / 100);

              this.querySelector('.js-one-time-purchase-price').innerHTML = '$' + getCurrentPrice;

              this.subscribePriceChange(data, this.querySelector('.js-custom-plan-input:checked').value)

              // this.querySelector('.js-subscription-purchase-price').innerHTML = '$' + getSellingCurrentPrice;

              const sellingPlanId = currentVariant.selling_plan_allocations[0].selling_plan_id;
              const getVariantWthSellingPlan = data.selling_plan_groups
                .flatMap(p => p.selling_plans)
                .find(id => id.id == sellingPlanId);
              const getPercentageValue = getVariantWthSellingPlan.price_adjustments[0].value;

              // this.jsDiscountLabel.innerHTML = `Save ${getPercentageValue}%`;
            };

            if (locationVarinaId) {
              const getCurrentVariantid = data.variants.find(v => v.id == locationVarinaId);
              catchVariant(getCurrentVariantid);
            } else {
              catchVariant(data.variants[0]);
            }
          }, 300);
        };


        changePrice();


        container.addEventListener('change', (e) => {

            changePrice();

            
        });
    }

  }

  
    customElements.define('subscribe-custom-widget', SubscribeCustomWidget);
  }
  } catch(e) { console.error(e); }
})();

})();
